import { useEffect, useState } from "react";
import { FaArrowDownShortWide, FaArrowUpShortWide, FaFilter, FaRotateLeft, FaXmark } from "react-icons/fa6";

const SORT_OPTIONS = [
    { value: "created_at", label: "Tanggal Dibuat" },
    { value: "username", label: "Username" },
    { value: "status", label: "Status" },
];

const STATUS_OPTIONS = [
    { value: "active", label: "Aktif" },
    { value: "used", label: "Terpakai" },
    { value: "nonaktif", label: "Nonaktif" },
];

export const FilterDrawer = ({ open, setOpen, currentParams, onApply, FILTER_DEFAULTS }) => {
    const [form, setForm] = useState(FILTER_DEFAULTS);

    useEffect(() => {
        if (open) {
            setForm({
                mitra_id: currentParams.mitra_id || "",
                reseller_id: currentParams.reseller_id || "",
                profile_id: currentParams.profile_id || "",
                status: currentParams.status || "",
                date_from: currentParams.date_from || "",
                date_to: currentParams.date_to || "",
                sort_by: currentParams.sort_by || "created_at",
                sort_dir: currentParams.sort_dir || "desc",
            });
        }
    }, [open, currentParams]);

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    const activeCount = Object.entries(form).filter(([k, v]) => {
        if (k === "sort_by" || k === "sort_dir") return false;
        return v !== "" && v !== null && v !== undefined;
    }).length;

    const handleReset = () => setForm(FILTER_DEFAULTS);
    const handleApply = () => { onApply(form); setOpen(false); };

    const selectStyle = "w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all appearance-none cursor-pointer";
    const selectArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2394a3b8' viewBox='0 0 16 16'%3E%3Cpath d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E")`;

    return (
        <>
            <div className={`fixed inset-0 z-[998] bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`} onClick={() => setOpen(false)} />
            <div className={`fixed top-0 right-0 z-[999] h-full w-full max-w-md shadow-2xl transition-transform duration-300 ease-out ${open ? "translate-x-0" : "translate-x-full"}`}
                style={{ background: "rgba(15,23,42,0.98)", borderLeft: "1px solid rgba(51,65,85,0.3)", backdropFilter: "blur(20px)" }}>

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5" style={{ borderBottom: "1px solid rgba(51,65,85,0.25)" }}>
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: "rgba(0,180,216,0.12)", border: "1px solid rgba(0,180,216,0.2)" }}>
                            <FaFilter className="text-sm text-cyan-400" />
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-100 text-sm">Filter Voucher</h3>
                            {activeCount > 0 && <p className="text-[10px] text-cyan-400 mt-0.5">{activeCount} filter aktif</p>}
                        </div>
                    </div>
                    <button onClick={() => setOpen(false)} className="p-2 rounded-xl text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                        <FaXmark size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="overflow-y-auto px-6 py-5 space-y-5" style={{ height: "calc(100% - 140px)" }}>

                    {/* Mitra & Reseller */}
                    <div>
                        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3">Distribusi</p>
                        <div className="space-y-3">
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Mitra</label>
                                <input type="text" value={form.mitra_id} onChange={(e) => setForm((f) => ({ ...f, mitra_id: e.target.value }))}
                                    placeholder="Cari atau masukkan ID mitra" className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                            </div>
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Reseller</label>
                                <input type="text" value={form.reseller_id} onChange={(e) => setForm((f) => ({ ...f, reseller_id: e.target.value }))}
                                    placeholder="Cari atau masukkan ID reseller" className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                            </div>
                        </div>
                    </div>

                    <div style={{ borderTop: "1px dashed rgba(51,65,85,0.25)" }} />

                    {/* Profile & Status */}
                    <div>
                        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3">Klasifikasi</p>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Profile</label>
                                <input type="text" value={form.profile_id} onChange={(e) => setForm((f) => ({ ...f, profile_id: e.target.value }))}
                                    placeholder="ID atau nama profile" className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                            </div>
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Status</label>
                                <select value={form.status} onChange={(e) => setForm((f) => ({ ...f, status: e.target.value }))}
                                    className={`${selectStyle}`} style={{ backgroundImage: selectArrow, backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center" }}>
                                    <option value="">Semua</option>
                                    {STATUS_OPTIONS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div style={{ borderTop: "1px dashed rgba(51,65,85,0.25)" }} />

                    {/* Tanggal */}
                    <div>
                        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3">Rentang Tanggal</p>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Dari</label>
                                <input type="date" value={form.date_from} onChange={(e) => setForm((f) => ({ ...f, date_from: e.target.value }))}
                                    className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                            </div>
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Sampai</label>
                                <input type="date" value={form.date_to} onChange={(e) => setForm((f) => ({ ...f, date_to: e.target.value }))}
                                    className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                            </div>
                        </div>
                    </div>

                    <div style={{ borderTop: "1px dashed rgba(51,65,85,0.25)" }} />

                    {/* Sort */}
                    <div>
                        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3">Pengurutan</p>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Urutkan</label>
                                <select value={form.sort_by} onChange={(e) => setForm((f) => ({ ...f, sort_by: e.target.value }))}
                                    className={`${selectStyle}`} style={{ backgroundImage: selectArrow, backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center" }}>
                                    {SORT_OPTIONS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-[10px] text-slate-500 font-semibold mb-1.5 uppercase tracking-wider">Arah</label>
                                <button type="button" onClick={() => setForm((f) => ({ ...f, sort_dir: f.sort_dir === "desc" ? "asc" : "desc" }))}
                                    className="w-full flex items-center justify-center gap-2 px-3 py-2.5 text-sm rounded-xl border transition-all"
                                    style={{ background: form.sort_dir === "desc" ? "rgba(0,180,216,0.08)" : "rgba(251,146,60,0.08)", borderColor: form.sort_dir === "desc" ? "rgba(0,180,216,0.2)" : "rgba(251,146,60,0.2)", color: form.sort_dir === "desc" ? "#22d3ee" : "#fb923c" }}>
                                    {form.sort_dir === "desc" ? <><FaArrowDownShortWide size={14} />Terbaru</> : <><FaArrowUpShortWide size={14} />Terlama</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="absolute bottom-0 left-0 right-0 flex gap-3 px-6 py-4"
                    style={{ background: "rgba(15,23,42,0.98)", borderTop: "1px solid rgba(51,65,85,0.25)", backdropFilter: "blur(20px)" }}>
                    <button type="button" onClick={handleReset}
                        className="flex items-center justify-center gap-2 flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold border transition-all"
                        style={{ background: "rgba(51,65,85,0.15)", borderColor: "rgba(51,65,85,0.3)", color: "#94a3b8" }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(239,68,68,0.08)"; e.currentTarget.style.borderColor = "rgba(239,68,68,0.2)"; e.currentTarget.style.color = "#f87171"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(51,65,85,0.15)"; e.currentTarget.style.borderColor = "rgba(51,65,85,0.3)"; e.currentTarget.style.color = "#94a3b8"; }}>
                        <FaRotateLeft size={13} />Reset
                    </button>
                    <button type="button" onClick={handleApply}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-cyan-600 hover:bg-cyan-500 transition-all shadow-lg shadow-cyan-600/20">
                        Terapkan
                    </button>
                </div>
            </div>
        </>
    );
};